export default __webpack_public_path__ + "videos/mallard_video1.8b90fa15757b50556b99ae61171c1a56.m4v";